<template>
    <BasicDrawer :duration="duration / 1000" ref="basicDrawerRef" v-if="show">
        <template v-slot:header>
            <div class="cancel-button" @click="closeDrawer">取消</div>

            <div class="header-title">
                <div class="title-label">选择兴趣标签</div>
            </div>

            <div class="confirm-button" @click="confirm">完成({{ checkInterest.length }})</div>
        </template>

        <template>
            <div class="interest-box">
                <div class="interest-box_left">
                    <div
                        :class="['interest-group', { 'is-check': currentInterestGroup === item.label }]"
                        v-for="item in intersetGroupList"
                        :key="item.label"
                        @click="currentInterestGroup = item.label"
                    >
                        {{ item.label }}

                        <div class="check-count" v-if="getCheckCount(item) > 0">{{ getCheckCount(item) }}</div>
                    </div>
                </div>

                <div class="interest-box_right">
                    <div :class="['all-check', { 'is-check': isAllCheck }]" @click="handleAllCheck">
                        <div class="check-icon"><i class="iconfont">&#xe63b;</i></div>
                        <span>全选</span>
                    </div>

                    <div class="interest-list">
                        <div
                            :class="['interest-item', { 'is-check': checkInterest.includes(item) }]"
                            v-for="item in getInterestList"
                            :key="item"
                            @click="handleCheckInterest(item)"
                        >
                            {{ item }}
                        </div>
                    </div>
                </div>
            </div>
        </template>
    </BasicDrawer>
</template>

<script>
import BasicDrawer from "./BasicDrawer.vue";
import interest from "@/utils/training-data/interest.json";

export default {
    name: "InterestDrawer",
    components: {
        BasicDrawer,
    },
    props: {
        show: {
            type: Boolean,
            required: true,
        },
        checkList: {
            type: Array,
            required: true,
        },
        duration: {
            type: Number,
            default: 200,
        },
    },
    data() {
        return {
            checkInterest: [],
            intersetGroupList: interest,
            currentInterestGroup: interest[0].label,
        };
    },
    created() {},
    watch: {
        show(newVal) {
            if (newVal) {
                this.checkInterest = JSON.parse(JSON.stringify(this.checkList));
            }
        },
    },
    computed: {
        getInterestList() {
            const groupItem = this.intersetGroupList.find((item) => item.label === this.currentInterestGroup);

            if (groupItem) {
                return groupItem.children || [];
            } else {
                return [];
            }
        },

        // 当前页是否全选
        isAllCheck() {
            return this.getInterestList.every((item) => this.checkInterest.includes(item));
        },
    },
    methods: {
        // 选择兴趣标签
        handleCheckInterest(tag) {
            const interestIndex = this.checkInterest.findIndex((item) => item === tag);

            if (interestIndex !== -1) {
                this.checkInterest.splice(interestIndex, 1);
            } else {
                this.checkInterest.push(tag);
            }
        },

        // 全选和取消全选
        handleAllCheck() {
            if (this.isAllCheck) {
                // 取消全选
                this.getInterestList.forEach((tag) => {
                    const interestIndex = this.checkInterest.findIndex((item) => item === tag);

                    if (interestIndex !== -1) this.checkInterest.splice(interestIndex, 1);
                });
            } else {
                // 全选
                this.getInterestList.forEach((tag) => {
                    const interestIndex = this.checkInterest.findIndex((item) => item === tag);

                    if (interestIndex === -1) {
                        this.checkInterest.push(tag);
                    }
                });
            }
        },

        // 该兴趣组选中了多少
        getCheckCount(group) {
            const interestList = group.children || [];

            return (interestList.filter((tag) => this.checkInterest.includes(tag)) || []).length;
        },

        closeDrawer() {
            if (this.$refs.basicDrawerRef) {
                this.$refs.basicDrawerRef.hiddenDrawer();
            }

            setTimeout(() => {
                this.$emit("close");
                this.currentInterestGroup = interest[0].label;
            }, this.duration);
        },

        confirm() {
            this.$emit("confirm", this.checkInterest);

            this.closeDrawer();
        },
    },
};
</script>

<style scoped lang="scss">
* {
    font-family: PingFang-SC;
}

::v-deep .drawer-box_header {
    font-size: 13px;
    color: #323233;
    font-weight: 600;

    .header-title {
        text-align: center;

        .title-tip {
            font-weight: 500;
            color: #999999;
            font-size: 12px;
            margin-top: 2px;
        }
    }

    .cancel-button,
    .confirm-button {
        width: 43px;
        cursor: pointer;
    }

    .confirm-button {
        color: #fc2b55;
        flex-shrink: 0;
        font-size: 13px;
        text-wrap: nowrap;
    }
}

::v-deep .drawer-box_content {
    padding: 0 !important;

    .interest-box {
        height: 400px;
        display: flex;

        &_left {
            flex-shrink: 0;
            height: 100%;
            width: 80px;
            overflow: auto;
            border-right: 1px solid #f1f1f1;
            scrollbar-width: none;

            &::-webkit-scrollbar {
                display: none;
            }

            .interest-group {
                padding: 12px 12px 12px 12px;
                box-sizing: border-box;
                font-size: 12px;
                text-align: center;
                white-space: nowrap; /* 强制单行显示 */
                overflow: hidden; /* 超出部分隐藏 */
                text-overflow: ellipsis; /* 显示省略号 */
                position: relative;
                cursor: pointer;
                position: relative;

                &.is-check {
                    // background-color: #f8f8f8;
                    color: #fc2b55;
                }

                .check-count {
                    position: absolute;
                    top: 5px;
                    right: 2px;
                    width: 16px;
                    height: 16px;
                    background-color: #fc2b55;
                    color: #ffffff;
                    font-size: 10px;
                    border-radius: 50%;
                    text-align: center;
                    line-height: 16px;
                }
            }
        }

        &_right {
            flex-shrink: 0;
            height: 100%;
            width: calc(100% - 81px);
            overflow: auto;
            scrollbar-width: none;
            box-sizing: border-box;
            padding: 12px;

            &::-webkit-scrollbar {
                display: none;
            }

            .all-check {
                color: #8d8d8d;
                font-size: 13px;
                cursor: pointer;
                display: flex;
                align-items: center;
                gap: 4px;

                .check-icon {
                    border-radius: 50%;
                    width: 14px;
                    height: 14px;
                    border: 1px solid #dddddd;
                    display: flex;
                    align-items: center;

                    .iconfont {
                        background-color: #ffffff;
                        color: #fc2b55;
                        border-radius: 50%;
                        display: none;
                    }
                }

                &.is-check {
                    .iconfont {
                        display: block;
                    }
                }
            }

            .interest-list {
                display: flex;
                flex-wrap: wrap;
                gap: 8px;
                margin-top: 10px;

                .interest-item {
                    width: calc((100% - 20px) / 3);
                    font-size: 12px;
                    border: 1px solid #f1f1f1;
                    border-radius: 2px;
                    box-sizing: border-box;
                    text-align: center;
                    padding-inline: 6px;
                    height: 26px;
                    line-height: 26px;
                    cursor: pointer;
                    white-space: nowrap; /* 强制单行显示 */
                    overflow: hidden; /* 超出部分隐藏 */
                    text-overflow: ellipsis; /* 显示省略号 */

                    &.is-check {
                        border-color: #fee3e8;
                        background-color: #fff3f5;
                        color: #fc2b55;
                    }
                }
            }
        }
    }
}
</style>
